// extracted by mini-css-extract-plugin
export default {"tab":"ActivitiesCenter_tab__wIKME","buttons":"ActivitiesCenter_buttons__jB2O1","deleteButtons":"ActivitiesCenter_deleteButtons__rzL4m"};